import { render, staticRenderFns } from "./Has1Acre.vue?vue&type=template&id=45d424ed"
import script from "./Has1Acre.vue?vue&type=script&lang=js"
export * from "./Has1Acre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports